"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const application_logger_1 = require("../application-logger");
class EventDelivery {
    constructor(sdkKey, ingestionUrl) {
        this.sdkKey = sdkKey;
        this.ingestionUrl = ingestionUrl;
    }
    /**
     * Delivers a batch of events to the ingestion URL endpoint. Returns the UUIDs of any events from
     * the batch that failed ingestion.
     */
    async deliver(batch, context) {
        try {
            application_logger_1.logger.info(`[EventDispatcher] Delivering batch of ${batch.length} events to ${this.ingestionUrl}...`);
            const response = await fetch(this.ingestionUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'x-eppo-token': this.sdkKey },
                body: JSON.stringify({ eppo_events: batch, context }),
            });
            if (response.ok) {
                return await this.parseFailedEvents(response, batch);
            }
            else {
                return { failedEvents: batch };
            }
        }
        catch (e) {
            application_logger_1.logger.warn(`Failed to upload event batch`, e);
            return { failedEvents: batch };
        }
    }
    async parseFailedEvents(response, batch) {
        application_logger_1.logger.info('[EventDispatcher] Batch delivered successfully.');
        const responseBody = (await response.json());
        const failedEvents = new Set(responseBody?.failed_events || []);
        if (failedEvents.size > 0) {
            application_logger_1.logger.warn(`[EventDispatcher] ${failedEvents.size}/${batch.length} events failed ingestion.`);
            // even though some events may have failed to successfully deliver, we'll still consider
            // the batch as a whole to have been delivered successfully and just re-enqueue the failed
            // events for retry later
            return { failedEvents: batch.filter(({ uuid }) => failedEvents.has(uuid)) };
        }
        else {
            return { failedEvents: [] };
        }
    }
}
exports.default = EventDelivery;
//# sourceMappingURL=event-delivery.js.map